var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDotsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 225 225"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 1.1c-36.6 4.6-71.3 30.2-87 64.2-13.6 29.4-13.6 65 0 94.4 10.4 22.4 30.8 43.2 53 53.8 37.5 18 82.5 14 115.1-10.3 57-42.5 62.1-123.5 10.8-172.2C164.6 7.4 132-3.2 97.5 1.1zm34 18.5c28.3 5.4 53.6 25.1 66.5 51.7 22.5 46.7 3 103.3-43.5 126.2-55.8 27.5-122.2-5-135-66-2.2-10.4-2.2-27.6 0-38 8.5-40.6 42.1-71.1 83.2-75.4 9.3-1 17.9-.5 28.8 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 102.1c-6.9 6.1-6.9 14.8.1 20.9 8.5 7.4 22.4 1 22.4-10.3 0-8.1-5.8-13.7-14.2-13.7-3.9 0-5.4.6-8.3 3.1zM102.9 102.9c-3.6 3.6-3.9 4.3-3.9 9.6s.3 6 3.9 9.6c3.6 3.6 4.3 3.9 9.6 3.9s6-.3 9.6-3.9c3.6-3.6 3.9-4.3 3.9-9.6s-.3-6-3.9-9.6c-3.6-3.6-4.3-3.9-9.6-3.9s-6 .3-9.6 3.9zM147.3 101c-8.6 5.2-8.2 18.9.6 23.5 1.7.8 5 1.5 7.5 1.5 3.6 0 5.2-.6 8.1-3.1 6.9-6.1 6.9-14.8-.1-20.9-2.8-2.4-4.4-3-8.2-3-2.9 0-5.9.8-7.9 2z"
  })));
}

export default SvgDotsinline;